import React from 'react'
import { Query as QueryComponent } from '@apollo/client/react/components'
import { fetchPolicy as globalFetchPolicy } from 'config/graphql'
import useFetchMoreState from '../useFetchMoreState'
import { transformData } from '../utils'
import produce from 'immer'
import set from 'lodash/set'
import get from 'lodash/get'
import { LIST_QUERY_LIMIT } from 'config/consts'

const ListQuery = ({ query, queryRef, fetchPolicy, variables: customVars = {}, sort, search, filter, limit = LIST_QUERY_LIMIT, children, ...props }) => {
	const [fetchMoreState] = useFetchMoreState()
	const queryVariables = {
		...customVars,
		params: {
			limit,
			sort,
			...((search && search.string) && { search })
		},
		filter: {
			...filter,
			...customVars.filter
		}
	}
	return(
		<QueryComponent
			query={query}
			fetchPolicy={fetchPolicy || globalFetchPolicy}
			errorPolicy='all'
			notifyOnNetworkStatusChange={true}
			variables={queryVariables}
			{...props}
		>
			{res => {
				if(queryRef) {
					queryRef.current = res
				}
				const { data, fetchMore, variables, ...rest } = fetchMoreState(res)
				const { data: transformedData, ...dataInfo } = transformData(data, { queryFieldExtract: true })

				let out = {
					...rest,
					...dataInfo,
					withData: true,
					data: []
				}

				if(transformedData) {
					const { items = [], hasNextPage, total } = transformedData
					const isDataConnection = !Array.isArray(transformedData)
					if(!rest.error && !rest.loading && isDataConnection && typeof hasNextPage === 'undefined') {
						throw new Error(`Connection ${transformedData.__typename} did not load 'hasNextPage' flag`)
					}
					const clientData = isDataConnection ? items : transformedData
					const { params } = variables

					out = {
						...out,
						total,
						data: clientData,
						loadMore: () => fetchMore({
							variables: {
								params: {
									...params,
									offset: items.length
								}
							},
							updateQuery: (prev = {}, { fetchMoreResult }) => {
								if (!fetchMoreResult) {
									return prev
								}
								const qwe = produce(prev, draft => {
									const { data: newData, appField, queryField } = transformData(fetchMoreResult, { queryFieldExtract: true })
									const objPath = appField ? `${appField}.${queryField}` : queryField
									const newItems = [...get(draft, `${objPath}.items`, []), ...newData.items]
									set(draft, objPath, { ...newData, items: newItems })
								})
								return qwe
							}
						})
					}
				}
				return(children(out))
			}}
		</QueryComponent>
	)
}

export default ListQuery
